export default "<div>\n<span>Hello</span>\n<span>World</span>\n</div>"